import get from 'lodash/get';

export const getOneOf = (objects, path, defValue) => {
  const reduced = objects.reduce((ret, object) => {
    return ret !== undefined ? ret : get(object, path);
  }, undefined);
  return (reduced !== undefined) ? reduced : defValue;
}